export const getNormalizedSelectionRect = draft => {
  if (!draft) {
    return null;
  }
  const minX = Math.min(draft.startX, draft.currentX);
  const minY = Math.min(draft.startY, draft.currentY);
  const maxX = Math.max(draft.startX, draft.currentX);
  const maxY = Math.max(draft.startY, draft.currentY);
  return {
    x: minX,
    y: minY,
    w: maxX - minX,
    h: maxY - minY,
  };
};

export const rectsIntersect = (a, b) =>
  Boolean(
    a &&
      b &&
      a.x < b.x + b.w &&
      a.x + a.w > b.x &&
      a.y < b.y + b.h &&
      a.y + a.h > b.y,
  );
